import { useState } from "react";
import { NavLink } from "react-router-dom";
import "./style.scss";

const Navigator: React.FC = () => {
  //Usestate variable to store whether to show the extended vertical menu
  const [showMenu, setShowMenu] = useState<boolean>(false);

  return (
    <nav className="Navigator" aria-label="Main Navigation">
      <div className="horizontalNavigator flexDisplay noGap">
        <NavLink
          to="/"
          className={({ isActive }) =>
            `navItem flexItems ${isActive ? "active" : ""}`
          }
        >
          <p className="flexItems subheading">Home</p>
        </NavLink>
        <NavLink
          to="/Services"
          className={({ isActive }) =>
            `navItem flexItems ${isActive ? "active" : ""}`
          }
        >
          <p className="flexItems subheading">Our Services</p>
        </NavLink>
        <NavLink
          to="/Reviews"
          className={({ isActive }) =>
            `navItem flexItems ${isActive ? "active" : ""}`
          }
        >
          <p className="flexItems subheading">Reviews</p>
        </NavLink>
        <NavLink
          to="/Contact"
          className={({ isActive }) =>
            `navItem flexItems ${isActive ? "active" : ""}`
          }
        >
          <p className="flexItems subheading">Contact Us</p>
        </NavLink>
      </div>

      <div className="verticalNavigator">
        <button
          onClick={() => setShowMenu(!showMenu)}
          id="menuSpan"
          className="material-symbols-outlined"
          aria-label="Toggle Menu"
        >
          menu
        </button>
        {showMenu && (
          <div className="verticalMenu">
            <NavLink
              to="/"
              className="navItem"
              onClick={() => setShowMenu(false)}
            >
              <p>Home</p>
            </NavLink>
            <NavLink
              to="/Services"
              className="navItem"
              onClick={() => setShowMenu(false)}
            >
              <p>Our Services</p>
            </NavLink>
            <NavLink
              to="/Reviews"
              className="navItem"
              onClick={() => setShowMenu(false)}
            >
              <p>Reviews</p>
            </NavLink>
            <NavLink
              to="/Contact"
              className="navItem"
              onClick={() => setShowMenu(false)}
            >
              <p>Contact Us</p>
            </NavLink>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigator;
